import { Button, createStyles, TextField, Theme, Typography, WithStyles, withStyles } from '@material-ui/core'
import React from 'react'
import validator from 'validator'
import DefaultLoaderModal from '../../components/DefaultLoaderModal/DefaultLoaderModal'

import { sendEmailRequest } from '../../services/email.service'
import { isIE } from '../../services/utils'

interface LoginFormProps extends WithStyles<typeof styles> {}
interface LoginFormState {
	email: string
	emailRequestSent: boolean
	loading: boolean
	requestMessage: string
}

const DEFAULT_SUCCESS_MESSAGE =
	'Thank you, your email address has been submitted. You should receive an email with ' +
	'further instructions.\n If you do not receive an email within 30 minutes, please contact your Grant Advisor.'
const DEFAULT_SERVICE_FAILURE_MESSAGE = 'Sorry, something went wrong. Please try again later.'
const INITIAL_STATE: LoginFormState = {
	email: '',
	emailRequestSent: false,
	loading: false,
	requestMessage: DEFAULT_SUCCESS_MESSAGE,
}

export class LoginForm extends React.Component<LoginFormProps, LoginFormState> {
	public readonly state: LoginFormState = INITIAL_STATE

	private formRef: React.RefObject<HTMLFormElement> = React.createRef()
	private inputRef: React.RefObject<HTMLFormElement> = React.createRef()

	validate = () => {
		const form = this.formRef.current

		if (form) return isIE ? validator.isEmail(this.state.email) : form.reportValidity()

		return false
	}

	handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		this.setState({ email: e.target.value })
	}

	setRequestMessage = (msg: string) => {
		this.setState(() => ({
			emailRequestSent: true,
			requestMessage: msg,
			loading: false,
		}))
	}

	handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		const isFormValid = this.validate()

		if (isFormValid) {
			this.setState({
				loading: true,
			})
			const validEmail = this.inputRef.current

			if (validEmail && validator.isEmail(this.state.email)) {
				sendEmailRequest(this.state.email)
					.then(() => {
						this.setRequestMessage(DEFAULT_SUCCESS_MESSAGE)
					})
					.catch((error) => {
						this.setRequestMessage(DEFAULT_SERVICE_FAILURE_MESSAGE)
					})
			}
		}
	}

	render() {
		const { classes } = this.props
		const { email, emailRequestSent, loading, requestMessage } = this.state

		return emailRequestSent ? (
			<Typography align="center" variant="h5" data-auto="message">
				{requestMessage}
			</Typography>
		) : (
			<React.Fragment>
				{loading && <DefaultLoaderModal loading={loading} />}
				<form onSubmit={this.handleSubmit} className={classes.signUpForm} ref={this.formRef} data-auto="Login form">
					<TextField
						value={email}
						type={email}
						autoFocus={true}
						fullWidth={true}
						id="outlined-bare"
						className={classes.textField}
						placeholder="Please enter your Email address:"
						margin="normal"
						variant="outlined"
						InputProps={{
							inputProps: {
								title: 'Please Provide A Valid Email Address.',
								className: classes.input,
								name: 'email',
								maxLength: 255,
								ref: this.inputRef,
								type: 'email',
							},
						}}
						required={true}
						onChange={this.handleInputChange}
					/>

					<Button variant="contained" color="default" className={classes.button} data-auto="submit" type="submit">
						Submit
					</Button>
				</form>
			</React.Fragment>
		)
	}
}

const styles = (theme: Theme) =>
	createStyles({
		signUpForm: {
			display: 'flex',
			flexDirection: 'column',
			alignSelf: 'center',
			justifySelf: 'center',

			margin: '0 auto',

			[theme.breakpoints.up('lg')]: {
				width: '70%',
			},
			[theme.breakpoints.up('md')]: {
				width: '80%',
			},
			[theme.breakpoints.only('sm')]: {
				width: '65%',
			},
			[theme.breakpoints.only('xs')]: {
				width: '90%',
			},
		},
		textField: {},
		button: {
			width: '20%',
			margin: '0 auto',
			minWidth: '100px',
		},
		input: {
			textAlign: 'center',
		},
	})

export default withStyles(styles)(LoginForm)
